// removed by extract-text-webpack-plugin
module.exports = {"form-control--caption-textarea":"form-control--caption-textarea","formControlCaptionTextarea":"form-control--caption-textarea"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/__future__/MediaUpload/CaptionTextarea.module.scss
// module id = 703
// module chunks = 0